import isEmpty from 'lodash/isEmpty';

const formatDuration = (duration, unitSingular = '', unitPlural = '') => {
    const toFloat = parseFloat(duration);
    const value = toFloat % 1 !== 0
        ? toFloat.toFixed(1)
        : toFloat.toFixed(0);

    const plural = !isEmpty(unitPlural) ? unitPlural : unitSingular;
    const unit = toFloat > 1 ? plural : unitSingular;

    return !isEmpty(unit) ? `${value} ${unit}` : value;
};

export {
    formatDuration
};
